<template>
  <div class="features-prod-cats-layout349 thq-section-padding">
    <div class="features-prod-cats-max-width thq-section-max-width">
      <div class="features-prod-cats-container1">
        <h2 class="thq-heading-2">
          <slot name="heading1">
            <!--Default content for heading1-->
            <div class="features-prod-cats-fragment19">
              <span class="features-prod-cats-text33">
                Discover the Features of Wildwood Herbs
              </span>
            </div>
          </slot>
        </h2>
        <span class="features-prod-cats-text11 thq-body-small">
          <slot name="content1">
            <!--Default content for content1-->
            <div class="features-prod-cats-fragment13">
              <span class="features-prod-cats-text27">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse varius enim in eros elementum tristique. Duis cursus,
                mi quis viverra ornare, eros dolor interdum nulla.
              </span>
            </div>
          </slot>
        </span>
      </div>
      <div class="features-prod-cats-container2 thq-grid-auto-300">
        <router-link to="/products-tea">
          <div class="features-prod-cats-card1 thq-card thq-flex-column">
            <img
              :alt="feature1ImageAlt"
              :src="feature1ImageSrc"
              class="features-prod-cats-image1 thq-img-round thq-img-ratio-1-1"
            />
            <h2 class="thq-heading-2">
              <slot name="feature1Title">
                <!--Default content for feature1Title-->
                <div class="features-prod-cats-fragment14">
                  <span class="features-prod-cats-text28">Herbal Teas</span>
                </div>
              </slot>
            </h2>
            <span class="features-prod-cats-text13 thq-body-small">
              <slot name="feature1Description">
                <!--Default content for feature1Description-->
                <div class="features-prod-cats-fragment21">
                  <span class="features-prod-cats-text35">
                    Indulge in our handcrafted herbal teas made from the finest
                    organic ingredients to soothe your mind and body.
                  </span>
                </div>
              </slot>
            </span>
          </div>
        </router-link>
        <router-link to="/products-body">
          <div class="features-prod-cats-card2 thq-card thq-flex-column">
            <img
              :alt="feature2ImageAlt"
              :src="feature2ImageSrc"
              class="features-prod-cats-image2 thq-img-round thq-img-ratio-1-1"
            />
            <h2 class="thq-heading-2">
              <slot name="feature2Title">
                <!--Default content for feature2Title-->
                <div class="features-prod-cats-fragment16">
                  <span class="features-prod-cats-text30">Body Butter</span>
                </div>
              </slot>
            </h2>
            <span class="features-prod-cats-text15 thq-body-small">
              <slot name="feature2Description">
                <!--Default content for feature2Description-->
                <div class="features-prod-cats-fragment12">
                  <span class="features-prod-cats-text26">
                    Nourish your skin with our luxurious body butter infused with
                    natural herbs and botanical extracts for a radiant glow.
                  </span>
                </div>
              </slot>
            </span>
          </div>
        </router-link>
        <router-link to="/products-soap">
          <div class="features-prod-cats-card3 thq-card thq-flex-column">
            <img
              :alt="feature3ImageAlt"
              :src="feature3ImageSrc"
              class="features-prod-cats-image3 thq-img-round thq-img-ratio-1-1"
            />
            <h1 class="thq-heading-2">
              <slot name="feature3Title">
                <!--Default content for feature3Title-->
                <div class="features-prod-cats-fragment15">
                  <span class="features-prod-cats-text29">Soaps</span>
                </div>
              </slot>
            </h1>
            <span class="features-prod-cats-text17 thq-body-small">
              <slot name="feature3Description">
                <!--Default content for feature3Description-->
                <div class="features-prod-cats-fragment10">
                  <span class="features-prod-cats-text24">
                    Transform your garden into a thriving oasis with our expert
                    gardening services tailored to your needs and preferences.
                  </span>
                </div>
              </slot>
            </span>
          </div>
        </router-link>
        <div class="features-prod-cats-card4 thq-card thq-flex-column">
          <img
            :alt="feature4ImageAlt"
            :src="feature4ImageSrc"
            class="features-prod-cats-image4 thq-img-round thq-img-ratio-1-1"
          />
          <h1 class="thq-heading-2">
            <slot name="feature4Title">
              <!--Default content for feature4Title-->
              <div class="features-prod-cats-fragment11">
                <span class="features-prod-cats-text25">
                  Personalized Consultations
                </span>
              </div>
            </slot>
          </h1>
          <span class="features-prod-cats-text19 thq-body-small">
            <slot name="feature4Description">
              <!--Default content for feature4Description-->
              <div class="features-prod-cats-fragment17">
                <span class="features-prod-cats-text31">
                  Embark on a holistic wellness journey with personalized
                  consultations from our experienced herbalists to address your
                  specific health concerns.
                </span>
              </div>
            </slot>
          </span>
        </div>
        <router-link to="/products-spritz">
          <div class="features-prod-cats-card5 thq-card thq-flex-column">
            <img
              :alt="feature5ImageAlt"
              :src="feature5ImageSrc"
              class="features-prod-cats-image5 thq-img-round thq-img-ratio-1-1"
            />
            <h1 class="thq-heading-2">
              <slot name="feature5Title">
                <!--Default content for feature5Title-->
                <div class="features-prod-cats-fragment22">
                  <span class="features-prod-cats-text36">Air Spritz</span>
                </div>
              </slot>
            </h1>
            <span class="features-prod-cats-text21 thq-body-small">
              <slot name="feature5Description">
                <!--Default content for feature5Description-->
                <div class="features-prod-cats-fragment20">
                  <span class="features-prod-cats-text34">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse varius enim in eros elementum tristique. Duis
                    cursus, mi quis viverra ornare, eros dolor interdum nulla.
                  </span>
                </div>
              </slot>
            </span>
          </div>
        </router-link>
        <div class="features-prod-cats-card6 thq-card thq-flex-column">
          <img
            :alt="feature6ImageAlt"
            :src="feature6ImageSrc"
            class="features-prod-cats-image6 thq-img-round thq-img-ratio-1-1"
          />
          <h1 class="thq-heading-2">
            <slot name="feature6Title">
              <!--Default content for feature6Title-->
              <div class="features-prod-cats-fragment23">
                <span class="features-prod-cats-text37">Feature #6</span>
              </div>
            </slot>
          </h1>
          <span class="features-prod-cats-text23 thq-body-small">
            <slot name="feature6Description">
              <!--Default content for feature6Description-->
              <div class="features-prod-cats-fragment18">
                <span class="features-prod-cats-text32">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse varius enim in eros elementum tristique. Duis
                  cursus, mi quis viverra ornare, eros dolor interdum nulla.
                </span>
              </div>
            </slot>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeaturesProdCats',
  props: {
    feature6ImageSrc: {
      type: String,
      default:
        'https://images.unsplash.com/photo-1597868067560-1dd6bd103d80?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczODA5MDkxMXw&ixlib=rb-4.0.3&q=80&w=1080',
    },
    feature5ImageSrc: {
      type: String,
      default:
        'https://images.unsplash.com/photo-1492496913980-501348b61469?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczODA5MDkxMXw&ixlib=rb-4.0.3&q=80&w=1080',
    },
    feature4ImageAlt: {
      type: String,
      default: 'Personalized Consultations Image',
    },
    feature5ImageAlt: {
      type: String,
      default: 'image',
    },
    feature3ImageAlt: {
      type: String,
      default: 'Gardening Services Image',
    },
    feature4ImageSrc: {
      type: String,
      default:
        'https://images.unsplash.com/photo-1569383971623-393054ce65c8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczODA5MDkxMXw&ixlib=rb-4.0.3&q=80&w=1080',
    },
    feature6ImageAlt: {
      type: String,
      default: 'image',
    },
    feature2ImageAlt: {
      type: String,
      default: 'Body Butter Image',
    },
    feature3ImageSrc: {
      type: String,
      default:
        'https://images.unsplash.com/photo-1553217420-e8f8dde808f7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczODA5MDkxMXw&ixlib=rb-4.0.3&q=80&w=1080',
    },
    feature1ImageSrc: {
      type: String,
      default:
        'https://images.unsplash.com/photo-1517453701121-ef2029e92915?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczODA5MDkxMXw&ixlib=rb-4.0.3&q=80&w=1080',
    },
    feature2ImageSrc: {
      type: String,
      default:
        'https://images.unsplash.com/photo-1659817673498-3c45390f7c61?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczODA5MDkxMXw&ixlib=rb-4.0.3&q=80&w=1080',
    },
    feature1ImageAlt: {
      type: String,
      default: 'Herbal Teas Image',
    },
  },
}
</script>

<style scoped>
.features-prod-cats-layout349 {
  gap: var(--dl-layout-space-twounits);
  display: flex;
  overflow: hidden;
  position: relative;
  align-items: center;
  flex-direction: column;
}
 
.features-prod-cats-max-width {
  display: flex;
  align-items: center;
  flex-direction: column;
}
 
.features-prod-cats-container1 {
  gap: var(--dl-layout-space-halfunit);
  display: flex;
  max-width: 600px;
  align-items: center;
  margin-bottom: var(--dl-layout-space-fourunits);
  flex-direction: column;
}
 
.features-prod-cats-text11 {
  text-align: center;
}
 
.features-prod-cats-container2 {
  width: 100%;
}
 
.features-prod-cats-card1 {
  color: var(--dl-color-theme-neutral-light);
  height: auto;
  display: flex;
  align-self: flex-start;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-decoration: none;
  background-color: var(--dl-color-theme-primary2);
}
 
.features-prod-cats-image1 {
  width: var(--dl-layout-size-medium);
  height: var(--dl-layout-size-medium);
  object-fit: cover;
}
 
.features-prod-cats-text13 {
  text-align: center;
}
 
.features-prod-cats-card2 {
  color: var(--dl-color-theme-neutral-light);
  height: auto;
  display: flex;
  align-self: flex-start;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-decoration: none;
  background-color: var(--dl-color-theme-primary1);
}
 
.features-prod-cats-image2 {
  width: var(--dl-layout-size-medium);
  height: var(--dl-layout-size-medium);
  object-fit: cover;
}
 
.features-prod-cats-text15 {
  text-align: center;
}
 
.features-prod-cats-card3 {
  color: var(--dl-color-theme-neutral-light);
  height: auto;
  display: flex;
  align-self: flex-start;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-decoration: none;
  background-color: var(--dl-color-theme-primary2);
}
 
.features-prod-cats-image3 {
  width: var(--dl-layout-size-medium);
  height: var(--dl-layout-size-medium);
  object-fit: cover;
}
 
.features-prod-cats-text17 {
  text-align: center;
}
 
.features-prod-cats-card4 {
  color: var(--dl-color-theme-neutral-light);
  height: auto;
  display: none;
  align-self: flex-start;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: var(--dl-color-theme-primary1);
}
 
.features-prod-cats-image4 {
  width: var(--dl-layout-size-medium);
  height: var(--dl-layout-size-medium);
  object-fit: cover;
}
 
.features-prod-cats-text19 {
  text-align: center;
}
 
.features-prod-cats-card5 {
  color: var(--dl-color-theme-neutral-light);
  height: auto;
  display: flex;
  align-self: flex-start;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-decoration: none;
  background-color: var(--dl-color-theme-primary2);
}
 
.features-prod-cats-image5 {
  width: var(--dl-layout-size-medium);
  height: var(--dl-layout-size-medium);
  object-fit: cover;
}
 
.features-prod-cats-text21 {
  text-align: center;
}
 
.features-prod-cats-card6 {
  color: var(--dl-color-theme-neutral-light);
  height: auto;
  display: none;
  align-self: flex-start;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: var(--dl-color-theme-primary1);
}
 
.features-prod-cats-image6 {
  width: var(--dl-layout-size-medium);
  height: var(--dl-layout-size-medium);
  object-fit: cover;
}
 
.features-prod-cats-text23 {
  text-align: center;
}
 
.features-prod-cats-fragment10 {
  display: contents;
}
 
.features-prod-cats-text24 {
  display: inline-block;
}
 
.features-prod-cats-fragment11 {
  display: contents;
}
 
.features-prod-cats-text25 {
  display: inline-block;
}
 
.features-prod-cats-fragment12 {
  display: contents;
}
 
.features-prod-cats-text26 {
  display: inline-block;
}
 
.features-prod-cats-fragment13 {
  display: contents;
}
 
.features-prod-cats-text27 {
  display: inline-block;
}
 
.features-prod-cats-fragment14 {
  display: contents;
}
 
.features-prod-cats-text28 {
  display: inline-block;
}
 
.features-prod-cats-fragment15 {
  display: contents;
}
 
.features-prod-cats-text29 {
  display: inline-block;
}
 
.features-prod-cats-fragment16 {
  display: contents;
}
 
.features-prod-cats-text30 {
  display: inline-block;
}
 
.features-prod-cats-fragment17 {
  display: contents;
}
 
.features-prod-cats-text31 {
  display: inline-block;
}
 
.features-prod-cats-fragment18 {
  display: contents;
}
 
.features-prod-cats-text32 {
  display: inline-block;
}
 
.features-prod-cats-fragment19 {
  display: contents;
}
 
.features-prod-cats-text33 {
  display: inline-block;
}
 
.features-prod-cats-fragment20 {
  display: contents;
}
 
.features-prod-cats-text34 {
  display: inline-block;
}
 
.features-prod-cats-fragment21 {
  display: contents;
}
 
.features-prod-cats-text35 {
  display: inline-block;
}
 
.features-prod-cats-fragment22 {
  display: contents;
}
 
.features-prod-cats-text36 {
  display: inline-block;
}
 
.features-prod-cats-fragment23 {
  display: contents;
}
 
.features-prod-cats-text37 {
  display: inline-block;
}
 
@media(max-width: 991px) {
  .features-prod-cats-max-width {
    flex-direction: column;
  }
  .features-prod-cats-container1 {
    margin-bottom: var(--dl-layout-space-threeunits);
  }
}
 
@media(max-width: 767px) {
  .features-prod-cats-container1 {
    margin-bottom: var(--dl-layout-space-oneandhalfunits);
  }
  .features-prod-cats-card1 {
    width: 100%;
  }
  .features-prod-cats-card2 {
    width: 100%;
  }
  .features-prod-cats-card3 {
    width: 100%;
  }
  .features-prod-cats-card4 {
    width: 100%;
  }
  .features-prod-cats-card5 {
    width: 100%;
  }
  .features-prod-cats-card6 {
    width: 100%;
  }
}
</style>
